import { h, Component } from 'preact';
import cx from 'classnames';
import Item from './item';
import style from './style';
import { isCurrent, getSubnav, currentSkinTier } from './util';

/**
 * The Nav component renders a tree of items as user selectable options.
 * All items can contain a 'subnav' prop that is another list of items
 * that will be rendered recursively.
 *
 * @param {Array} props.items A list of items to render. items may have 'subnav' lists of items.
 * @param {String} props.current A path string to consider the currently selected item.
 * @param {Array} props.skin An array used for styling this component and all subnav tiers.
 * @param {Boolean} props.openLeft If true, subnavs will open facing leftward rather than rightward.
 * @param {Function} props.linkRenderer A function that can be used to render links items contents.
 * @param {String} props.type The trigger type for this nav's subnavs. (click, hover).
 * @param {String} props.innerType The trigger type for subnavs of this nav. (click, hover).
 *
 */
export default class Nav extends Component {

	/*
	You'd think Nav would be better off as a functional component, and it should...
	However, when defined as a functional component, the ref event does not seem to fire
	properly when used by menu-item in unit tests.

	Until we figure out why, this should stay class-based.
	*/
	render({ items = [], current, type, innerType = 'hover', skin, openLeft, linkRenderer, menuPropsGenerator, onMenuOpen, onLinkItemClick, role, delaySubnavRender, ...props }) {
		let skinTier = currentSkinTier(skin);
		let navComp = (
			<nav
				{...props}
				role={role ? role : items.length > 1 ? 'navigation' : 'none'}
				class={cx(
					style.nav,
					skinTier.nav,
					props.class,
					openLeft && style.openLeft,
					openLeft &&  skinTier.openLeft
				)}
			>
				{ items.map((item, i) => (
					<Item
						item={item}
						positionIndex={i}
						current={current}
						type={type}
						innerType={innerType}
						skin={skin}
						openLeft={openLeft}
						linkRenderer={linkRenderer}
						menuPropsGenerator={menuPropsGenerator}
						onMenuOpen={onMenuOpen}
						onLinkItemClick={onLinkItemClick}
						delaySubnavRender={delaySubnavRender}
					/>
				)) }
			</nav>
		);
		if (skinTier.chrome) return (
			<div class={cx(skinTier.chrome, openLeft &&  skinTier.openLeft)}>{navComp}</div>
		);
		return navComp;
	}
}

export { isCurrent };
export { getSubnav };